"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
var PredicateInput_1 = __importDefault(require("../../Mixins/PredicateInput"));
var SourceValue_1 = __importDefault(require("../../Mixins/SourceValue"));
var moment_addon_1 = __importDefault(require("../../../Addons/moment-addon"));
exports.default = vue_1.default.extend({
    props: ['name', 'label', 'required', 'placeholder', 'readonly'],
    mixins: [ConditionalDisplay_1.default, PredicateInput_1.default, SourceValue_1.default],
    data: function () {
        var model = this.$root.$data;
        return {
            internalReadonly: model.readOnly || this.readonly
        };
    },
    methods: {
        onChange: function () {
            this.$emit("change", $(this.$refs.pickerDate).val());
        }
    },
    watch: {
        defaultValue: function (n) {
            this.$set(this.$data, "value", n);
        }
    },
    mounted: function () {
        // Regex car on peut avoir un autre format que DD/MM/YYYY
        if (/^(\d{4})-(\d{2})-(\d{2})T(\d{2})\:(\d{2})\:(\d{2})$/.test(this.value)) {
            this.value = moment_addon_1.default.parseZone(this.value).format('DD/MM/YYYY');
        }
        var $input = $(this.$refs.pickerDate);
        var $icon = $(this.$refs.icon);
        var eventIcon = function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $input.data("DateTimePicker").toggle();
        };
        $input.datetimepicker({
            locale: 'fr',
            format: 'L'
        })
            .on("dp.hide", function () {
            setTimeout(function () {
                $icon.one('click', eventIcon);
            }, 300);
        })
            .on("dp.show", function () {
            $icon.off();
        });
        $icon.one('click', eventIcon);
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/DatepickerDate.vue
// module id = 187
// module chunks = 0